import { Feature, Point } from '@turf/helpers'
import { atom, selector } from 'recoil'

import { partnersClient } from 'src/clients'
import { browserLogger } from 'src/utils/browser-logger'
import { keyFactory } from 'src/utils/recoil'

const key = keyFactory('matthews')

export const isIframe = atom<boolean>({
  key: key('is-iframe'),
  default: false,
})

export const center = atom<Feature<Point> | undefined>({
  key: key('center'),
  default: undefined,
})

export const tenantName = atom<string | undefined>({
  key: key('tenantName'),
  default: undefined,
})

export const locationId = selector<string | undefined>({
  key: key('primary-location-id'),
  get: async ({ get }) => {
    const _center = get(center)
    const _tenantName = get(tenantName)
    if (_center && _tenantName) {
      try {
        return (
          await partnersClient.getMatthewsMatchedTenantLocationId({
            lat: _center.geometry.coordinates[1],
            lng: _center.geometry.coordinates[0],
            name: _tenantName,
          })
        ).id
      } catch (error) {
        browserLogger.error(error)
        return undefined
      }
    }
  },
})
